import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { array } from '@ember/helper';
import { service } from '@ember/service';
import { or } from 'ember-truth-helpers';
import Icon from './icon.gjs';

export default class NavigationMenuItem extends Component {
  @service router;

  <template>
    <li
      class={{if @iconOnly "tooltip tooltip-right"}}
      data-tip={{if @iconOnly @title}}
    >
      <LinkTo
        @route={{@route}}
        @current-when={{@route}}
        @models={{if @models @models (if @model (array @model) (array))}}
        @activeClass="menu-active"
      >
        <Icon @class="text-primary" @icon={{@icon}} @size="lg" class="w-5" />
        {{#unless @iconOnly}}
          {{@title}}
          {{#if @badge}}
            <span
              class="badge badge-sm badge-soft {{or @badgeClass 'badge-info'}}"
            >
              {{@badge}}
            </span>
          {{/if}}
        {{/unless}}
      </LinkTo>
    </li>
  </template>
}
